import { FC } from "react";
import { IconProps } from "./types";

export const ArrowUpCircleFilled: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 0c6.6 0 12 5.4 12 12s-5.4 12-12 12S0 18.6 0 12 5.4 0 12 0zm6 10.826a.595.595 0 0 0-.158-.392l-5.447-5.402A.605.605 0 0 0 12 4.875c-.04 0-.079.02-.118.04-.04.019-.08.038-.119.038 0 .049-.03.067-.072.093-.025.015-.056.034-.086.064l-5.447 5.402a.596.596 0 0 0-.158.392c0 .039.02.078.04.117.02.04.039.079.039.118.049 0 .067.03.093.071.016.025.035.055.065.085 0 .079.079.157.158.157.079.078.158.078.237.078.04 0 .079-.02.118-.039.04-.02.079-.04.118-.04 0-.048.03-.066.072-.091a.442.442 0 0 0 .086-.065l4.421-4.384v11.666c0 .156.08.313.158.391a.605.605 0 0 0 .395.157c.158 0 .316-.078.474-.157a.596.596 0 0 0 .158-.391V6.832l4.42 4.385a.606.606 0 0 0 .395.157.605.605 0 0 0 .395-.157c.158-.078.158-.235.158-.391z"
      fill={fill}
    />
  </svg>
);
